import makeApiCall from "./master/axiosIndex";
export const activityApis = {
  createActivity: async (data: any): Promise<any> => {
    return makeApiCall({ url: "/activity/create", method: "post", data });
  },
  updateActivity: async (data: any): Promise<any> => {
    return makeApiCall({ url: `/activity/update`, method: "put", data });
  },
  archiveActivity: async (activityId: any): Promise<any> =>
    makeApiCall({ url: `/activity/archive/${activityId}`, method: "patch" }),
  deleteActivity: async (activityId: any): Promise<any> =>
    makeApiCall({ url: `/activity/delete/${activityId}`, method: "delete" }),
  statusChangeActivity: async (
    activityId: any,
    status: string,
    activityOnHoldReason?: string,
    activityETAResolution?: string
  ): Promise<any> =>
    makeApiCall({
      url: `/activity/statusChange/${activityId}`,
      method: "patch",
      params: { status, activityOnHoldReason, activityETAResolution },
    }),
  fetchActivityList: async (params: any): Promise<any> =>
    makeApiCall({ url: "/activity/list", method: "get", params }),
  fetchActivityById: async (
    activityId: any,
    derivedProjectStatus?: string
  ): Promise<any> =>
    makeApiCall({
      url: `/activity/id/${activityId}`,
      method: "get",
      params: { derivedProjectStatus },
    }),

  getTagsFilterData: (projectId: any, phaseId: any): Promise<any> => {
    return makeApiCall({
      url: `/activity/filters/tags`,
      method: "get",
      params: { projectId, phaseId },
    });
  },
  getOwnersFilterData: (projectId: any, phaseId: any): Promise<any> => {
    return makeApiCall({
      url: `/activity/filters/owners`,
      method: "get",
      params: { projectIds: projectId, phaseId },
    });
  },
  changeActivityStatus: async (activityId: any, status: string): Promise<any> =>
    makeApiCall({
      url: `/activity/statusChange/${activityId}?status=${status}`,
      method: "patch",
    }),
  fetchGroupByActivityList: async (params: any, projectId: any): Promise<any> =>
    makeApiCall({
      url: "/activity/groupByList/" + projectId,
      method: "get",
      params,
    }),
  getPhaseActivityWeightage: (
    projectId: number,
    phaseId?: number
  ): Promise<any> =>
    makeApiCall({
      url: `/activity/phaseActivityWeightage`,
      method: "get",
      params: { projectId, phaseId },
    }),
};
